import { Locales } from "@intlayer/config/client";
const cacheKey = (locales, options) => JSON.stringify([locales, options]);
const createCachedConstructor = (Ctor) => {
  const cache = /* @__PURE__ */ new Map();
  function Wrapped(locales, options) {
    if (Ctor.name === "DisplayNames" && typeof Intl?.DisplayNames !== "function") {
      if (process.env.NODE_ENV === "development") {
        console.warn(
          `Intl.DisplayNames is not supported; falling back to raw locale (${locales}). Consider adding a polyfill as https://formatjs.io/docs/polyfills/intl-displaynames/`
        );
      }
      return locales;
    }
    const key = cacheKey(locales ?? Locales.ENGLISH, options);
    let instance = cache.get(key);
    if (!instance) {
      instance = new Ctor(locales, options);
      cache.set(key, instance);
    }
    return instance;
  }
  Wrapped.prototype = Ctor.prototype;
  return Wrapped;
};
const createCachedIntl = () => new Proxy(Intl, {
  get: (target, prop, receiver) => {
    const value = Reflect.get(target, prop, receiver);
    return typeof value === "function" && /^[A-Z]/.test(String(prop)) ? createCachedConstructor(value) : value;
  }
});
const CachedIntl = createCachedIntl();
export {
  CachedIntl as Intl,
  createCachedIntl
};
//# sourceMappingURL=intl.mjs.map